<template>
<ul class="casestudies">
		<li class="casestudies__dd">
			<a href="./projects/discovery-dial/">
				<div class="casestudies__description">
					<span class="heading--first">Discovery Dial</span>
					<span class="heading--second">A new way to explore Japan</span>
				</div>
			</a>
		</li>
			<li class="casestudies__plb">
			<a href="./projects/plant-life-balance/">
				<div class="casestudies__description">
					<span class="heading--first">Plant Life Balance</span>
				</div>
			</a>
		</li>
		<li class="casestudies__emojimaster">
			<a href="./projects/emojimaster/">
				<div class="casestudies__description">
					<span class="heading--first">Master of the Emoji</span>
				</div>
			</a>
		</li>
		<li class="casestudies__unseenjapan">
			<a href="./projects/unseenjapan/">
				<div class="casestudies__description">
					<span class="heading--first">Unseen Japan</span>
				</div>
			</a>
		</li>
		<li class="casestudies__fijinow">
			<a href="./projects/fijinow/">
				<div class="casestudies__description">
					<span class="heading--first">#FIJINOW</span>
						<span class="heading--second">Cyclone Recovery Campaign</span>
				</div>
			</a>
		</li>
		<li class="casestudies__themagicsakura">
			<a href="./projects/themagicsakura/">
				<div class="casestudies__description">
					<span class="heading--first">The Magic Sakura</span>
				</div>
			</a>
		</li>
		<li class="casestudies__amnesty">
			<a href="./projects/amnesty/">
				<div class="casestudies__description">
					<span class="heading--first">Amnesty International</span>
						<span class="heading--second">Make The Choice</span>
				</div>
			</a>
		</li>
	</ul>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "https://cdn.rawgit.com/murtaugh/HTML5-Reset/d48d053d/assets/css/reset.css";

@font-face {
	font-family: 'Bula';
	src: url('~@/assets/fonts/subset-Bula.eot');
	src: url('~@/assets/fonts/subset-Bula.eot?#iefix') format('embedded-opentype'),
		url('~@/assets/fonts/subset-Bula.woff') format('woff'),
		url('~@/assets/fonts/subset-Bula.ttf') format('truetype');
	font-weight: normal;
	font-style: normal;
}

@font-face {
	font-family: 'Pluto Cond';
	src: url('~@/assets/fonts/subset-PlutoCondExtraLight.eot');
	src: url('~@/assets/fonts/subset-PlutoCondExtraLight.eot?#iefix') format('embedded-opentype'),
		url('~@/assets/fonts/subset-PlutoCondExtraLight.woff') format('woff'),
		url('~@/assets/fonts/subset-PlutoCondExtraLight.ttf') format('truetype');
	font-weight: 200;
	font-style: normal;
}

@font-face {
	font-family: 'Bebas';
	src: url('~@/assets/fonts/Bebas.eot');
	src: url('~@/assets/fonts/Bebas.eot?#iefix') format('embedded-opentype'),
		url('~@/assets/fonts/Bebas.woff') format('woff'),
		url('~@/assets/fonts/Bebas.ttf') format('truetype');
	font-weight: normal;
	font-style: normal;
}

@font-face {
  font-family: 'Autor';
  src: url('~@/assets/fonts/autor/Autor-Light.eot'); /* IE9 Compat Modes */
  src: url('~@/assets/fonts/autor/Autor-Light.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('~@/assets/fonts/autor/Autor-Light.woff') format('woff'), /* Pretty Modern Browsers */
       url('~@/assets/fonts/autor/Autor-Light.ttf')  format('truetype'); /* Safari, Android, iOS */
  font-style: normal;
  font-weight: 300;
}

body {
	font-size: 23px; font-weight: normal; color: white;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html { overflow: scroll; overflow-y: hidden; }
ul.casestudies { display: flex; flex-direction: row; flex-wrap: nowrap; overflow-x: scroll; background-color: black;
	li { position: relative; flex: 0 0 auto;
		a { cursor: pointer; display: flex; width: 30vw; height: 100vh; text-align: center; text-decoration: none; position: relative; z-index: 10; transition: width 2s cubic-bezier(0, 0.4, 0, 1.18);
			.casestudies__description { position: relative; z-index: 2; margin: auto;
				span { display: block; }
			}
		}

		&.casestudies__plb {
			&:before { content: ""; display: block; width: 100%; height: 100%; position: absolute; top: 0; left: 0; background: #00A7B1 url(~@/assets/images/plb/bg.jpg) 50% 0 / cover no-repeat; filter: blur(6px); opacity: .4; z-index: 1; }
			.heading--first { width: 300px; height: 107px; background: transparent url(~@/assets/images/plb/logo.png) 0 0 / contain no-repeat; text-indent: 100%; white-space: nowrap; overflow: hidden; }
		}

		&.casestudies__emojimaster {
			&:before { content: ""; display: block; width: 100%; height: 100%; position: absolute; top: 0; left: 0; background: #00A7B1 url(~@/assets/images/emojimaster/bg.jpg) 50% 0 / cover no-repeat; filter: blur(6px); opacity: .4; z-index: 1; }
			.heading--first { width: 300px; height: 107px; background: transparent url(~@/assets/images/emojimaster/logo.png) 0 0 / contain no-repeat; text-indent: 100%; white-space: nowrap; overflow: hidden; }
		}

		&.casestudies__unseenjapan {
			&:before { content: ""; display: block; width: 100%; height: 100%; position: absolute; top: 0; left: 0; background: #00A7B1 url(~@/assets/images/unseenjapan/bg.jpg) 50% 0 / cover no-repeat; filter: blur(6px); opacity: .4; z-index: 1; }
			.heading--first { width: 197px; height: 107px; background: transparent url(~@/assets/images/unseenjapan/logo.png) 0 0 / cover; text-indent: 100%; white-space: nowrap; overflow: hidden; }
		}

		&.casestudies__fijinow {
			&:before { content: ""; display: block; width: 100%; height: 100%; position: absolute; top: 0; left: 0; background: #00A7B1 url(~@/assets/images/fijinow/bg.jpg) 50% 0 / cover no-repeat; filter: blur(6px); opacity: .4; z-index: 1; }
			.heading--first { font-family: 'Bula', sans-serif; font-size: 4rem; color: white; }
			.heading--second { font-family: 'Pluto Cond', sans-serif; font-size: 2rem; color: white; }
		}

		&.casestudies__themagicsakura {
			&:before { content: ""; display: block; width: 100%; height: 100%; position: absolute; top: 0; left: 0; background: #00A7B1 url(~@/assets/images/sakura/bg.jpg) 50% 0 / 100% no-repeat; filter: blur(6px); opacity: .4; z-index: 1; }
			.heading--first { width: 300px; height: 121px; background: transparent url(~@/assets/images/sakura/logo.png) 0 0 / cover; text-indent: 100%; white-space: nowrap; overflow: hidden; }
		}

		&.casestudies__amnesty {
			&:before { content: ""; display: block; width: 100%; height: 100%; position: absolute; top: 0; left: 0; background: black url(/projects/amnesty/images/AMnesty_Presentation_Page.jpg) 50% 0 / 100% no-repeat; filter: blur(6px); opacity: .4; z-index: 1; }
			.heading--first { font-family: 'Bebas', sans-serif; font-size: 3rem; color: white; }
			.heading--second { font-family: 'Bebas', sans-serif; font-size: 2rem; color: #FAF500; }
		}

		&.casestudies__dd {
			&:before { content: ""; display: block; width: 100%; height: 100%; position: absolute; top: 0; left: 0; background: black url(~@/assets/images/discovery-dial/bg.jpg) 50% 50% / cover no-repeat; filter: blur(6px); opacity: .4; z-index: 1; }
			.heading--first { font-family: 'Autor', sans-serif; font-weight: 300; font-size: 3rem; color: white; }
			.heading--second { font-family: 'Autor', sans-serif; font-size: 1.5rem; color: white; }
		}
	}

	li:hover { overflow: hidden;
		&:before { width: 110%; height: 110%; margin: -5% 0 0 -5%; transition: all .4s ease; }
		a { transform: scale(1.2); transition: all .4s ease; }
	}
}

@media screen and (max-width: 720px) {
  ul.casestudies { flex-direction: column;
	  li {
		  a { width: 100vw; height: 100vh; }
	  }
  }
}
</style>